import React from 'react'
import {Card as RawCard} from '@mui/material'

const Card = ({children, ...props}) => {
    return <RawCard {...props}>{children}</RawCard>
}

export default Card
